import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { logout } from "../actions/auth"
import {
	FileState,
	FilesListState,
	fetchFiles,
	getFiles,
} from "../actions/file"

const initialState: FilesListState = {
	loading: false,
	loadingFetch: false,
	error: undefined,
	errorFetch: undefined,
	list: [],
}

const filesListSlice = createSlice({
	name: "files",
	initialState: initialState,
	reducers: {
		clearError: (state: FilesListState) => {
			state.error = undefined
			state.loading = false
		},
		resetDefault: (state: FilesListState) => {
			state.loading = false
			state.loadingFetch = false
			state.error = undefined
			state.errorFetch = undefined
			state.list = []
		},
		updateStateForId: (
			state: FilesListState,
			action: PayloadAction<{
				id: number
				newState: string
				lastAuthorizedBy?: string
			}>
		) => {
			const { id, newState, lastAuthorizedBy } = action.payload
			const file = state.list.page.content.find((f) => f.id === id)
			if (file) {
				file.status = newState
				if (lastAuthorizedBy) {
					file.lastAuthorizedBy = lastAuthorizedBy
				}
			}
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(logout.fulfilled, () => initialState)
			.addCase(getFiles.pending, (state: FilesListState) => {
				state.loading = true
				state.error = undefined
			})
			.addCase(
				getFiles.fulfilled,
				(state: FilesListState, action: PayloadAction<FileState[]>) => {
					state.loading = false
					state.error = undefined
					state.list = action?.payload
				}
			)
			.addCase(
				getFiles.rejected,
				(state: FilesListState, action: PayloadAction<{ message: string }>) => {
					state.loading = false
					state.error = action?.payload?.message ?? "generic"
				}
			)
			.addCase(fetchFiles.pending, (state: FilesListState) => {
				state.loadingFetch = true
				state.errorFetch = undefined
			})
			.addCase(
				fetchFiles.fulfilled,
				(state: FilesListState, action: PayloadAction<FileState[]>) => {
					state.loadingFetch = false
					state.errorFetch = undefined
					state.list = {
						nextUrl: action?.payload.nextUrl,
						page: {
							...action?.payload.page,
							content: [
								...state.list.page.content,
								...action?.payload.page.content,
							],
						},
					}
				}
			)
			.addCase(fetchFiles.rejected, (state: FilesListState, action) => {
				state.loadingFetch = false
				state.errorFetch = action?.payload.message
			})
	},
})

export const { clearError, resetDefault, updateStateForId } =
	filesListSlice.actions

export default filesListSlice.reducer
